import { Box, CardMedia, Icon, Typography } from '@mui/material'
import UpskillTable from '../UpskillTable'
import UpskillApprovalModal from './UpskillApprovalModal'
import { useState } from 'react'
import { format } from 'date-fns'

const UpskillApprovalTab = ({
  data,
  isLoading,
  isError,
  type,
  lastPage,
  page,
  rowsPerPage,
  handleChangeRows,
  count,
  handleChangePage,
}) => {
  const tableColumn = [
    {
      id: 1,
      Header: 'Detail',
      accessor: 'course_name',
      Cell: (props) => {
        const { value } = props
        const formatDate = (inputDate) => {
          const formattedDate = format(new Date(inputDate), 'EEE, dd/MM/yyyy')
          return formattedDate
        }

        return (
          <Box display="flex" alignItems="center">
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="alternate.light"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'alternate.main',
                }}
              >
                text_snippet
              </Icon>
            </Box>

            <Box display="flex" flexDirection="column">
              <Typography>{value}</Typography>
              <Typography variant="subtitle2" color="light-gray-text.main">
                {formatDate(props?.row?.original?.apply_date)}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      id: 2,
      Header: 'Requester',
      accessor: 'requester_name',
      Cell: (props) => {
        const { value } = props

        return (
          <Box display="flex" alignItems="center">
            {props?.row?.original?.requester_image !== '' ? (
              <CardMedia
                component="img"
                sx={{
                  marginRight: 2,
                  height: 45,
                  width: 45,
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
                src={props?.row?.original?.requester_image}
              />
            ) : (
              <Box
                width={45}
                height={45}
                borderRadius="50%"
                bgcolor="gray-background.main"
                marginRight={2}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon
                  sx={{
                    color: 'light-gray-text.main',
                  }}
                >
                  person_outline_outlined
                </Icon>
              </Box>
            )}

            <Typography>{value}</Typography>
          </Box>
        )
      },
    },
  ]
  const [status, setStatus] = useState(type)
  const [id, setId] = useState()

  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = (item) => {
    setId(item.id)
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }

  return (
    <Box>
      <Box display="flex" flexDirection="column" mt={2} alignItems="center">
        <UpskillTable
          column={tableColumn}
          data={data?.data ?? []}
          nav="View"
          onClick={handleOpen}
          sxHeader
          sxNav
          sxCell
          isLoading={isLoading}
          error={isError}
          type={`${type} course`}
          lastPage={lastPage}
          count={count}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRows}
        />
      </Box>
      <UpskillApprovalModal
        isModalOpen={isModalOpen}
        handleClose={handleClose}
        handleOpen={handleOpen}
        status={status}
        setStatus={setStatus}
        id={id}
        type={type}
      />
    </Box>
  )
}
export default UpskillApprovalTab
